import { OnDestroy, Pipe, PipeTransform, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { BreakpointService } from '@core/services/breakpoint.service';

import { Breakpoint } from '../../../../../breakpoints/config';
import { AsyncPipeBase } from '../async-pipe-base';

@Pipe({
  name: 'up',
  pure: false,
  standalone: true,
})
export class UpPipe extends AsyncPipeBase<Breakpoint, [], boolean> implements PipeTransform, OnDestroy {
  readonly #breakpointService = inject(BreakpointService);

  protected readonly defaultValue = false;

  public transform$(value: Breakpoint): Observable<boolean> {
    return this.#breakpointService.isBreakpointActive$(value);
  }
}
